export default function() {
    if(typeof FundraiseUp !== 'undefined' && typeof FundraiseUp === 'function') {
        /* eslint-disable-next-line */
        // console.log('::::::::::::::::FUNDRAISE UP::::::::::::::::::::::::::::::::');
        // Object
        var FRUSitecore = {};
        // Endpoints
        FRUSitecore.donationEndpoint = `${window.location.origin}/aha-service/fundraise/track`;
        FRUSitecore.goalEndpoint = `${window.location.origin}/aha-service/analytics/TriggerGoal`;
        FRUSitecore.eventEndpoint = `${window.location.origin}/aha-service/analytics/trackevent`;

        FRUSitecore.mapData = function(vendorDataObj) {
            /* eslint-disable */
            // Destructuring assignments
            const { campaign, supporter, donation, tribute, customFields } = vendorDataObj;
            const {id} = campaign;

            if(supporter === null && donation === null) { return };

            const {
                firstName,
                lastName,
                email,
                mailingListSubscribed,
                employer,
                onBehalfOn
            } = supporter;

            const {
                amount,
                recurring
            } = donation;

            const data = {
                FirstName: firstName,
                LastName: lastName,
                Email: email,
                Amount: amount,
                GiftType: (tribute) ? 2 : 1,
                ContributionType: (recurring) ? 2 : 1,
                CustomFields: JSON.stringify(customFields),
                Employer: employer || '',
                Corporate: onBehalfOn || '',
                Newsletter: mailingListSubscribed
            };

            // console.log('Mapped data: ');
            // console.log(data);

            return data;
        };
        
        FRUSitecore.sendData = function(endpoint, dataObj) {
            // P O S T
            /* eslint-disable-next-line */
            console.log("Data Obj: ", dataObj);
            fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(dataObj)
            })
                .then(response => {
                    /* eslint-disable-next-line */
                    // console.log(response.status + ' - ' + response.statusText);
                    /*if(response) {
                        // return response.json();
                    }*/
                })
                .then(result => {
                    /*if(result) {
                        console.log('RESPONSE:', result);
                    }*/
                })
                .catch(error => {
                    /* eslint-disable-next-line */
                    console.log('ERROR:', error);
                    if(error.constructor === Object) {
                        /* eslint-disable-next-line */
                        console.error('ERROR:', error);
                    }
                });
        };

        FRUSitecore.triggerGoal = function(data) {
            /* eslint-disable-next-line */
            let _dataObj = data;
            _dataObj = _dataObj.replace(/'/g, '"');
            let obj = JSON.parse(_dataObj);
            let {goalId, ...pageEvent} = obj;
            let goalObj = {'goalId': goalId};
            // let pageEventObj = pageEvent;

            if(Object.keys(goalObj).length !== 0 && goalObj.constructor === Object) {
                FRUSitecore.sendData(FRUSitecore.goalEndpoint, goalObj);
            }

            // if(Object.keys(pageEventObj).length !== 0 && pageEventObj.constructor === Object) {
            //     FRUSitecore.sendData(FRUSitecore.eventEndpoint, pageEventObj);
            // }
        };

        // FRU Events
        FundraiseUp.on('checkoutOpen', function(details) {
            /* eslint-disable-next-line */
            console.log('CHECKOUT OPEN ::::::::::::::::::::');
            /* eslint-disable-next-line */
            console.log('Details: ', details);

            // Determine if its fru widget or button
            let _data = "";

            if(window.dataTrackingOpen == undefined){
                return;
            }
            _data = window.dataTrackingOpen;

            // If is widget
            // FRUSitecore.triggerGoal('data-tracking-open');
            FRUSitecore.triggerGoal(_data);
            // else use the global data object
            // console.log('OPEN: Data tracking String: ', dataTrackingOpen);
        });

        FundraiseUp.on('checkoutClose', function(details) {
            /* eslint-disable-next-line */
            console.log('CHECKOUT CLOSE :::::::::::::::::::');
            /* eslint-disable-next-line */
            console.log("Close Details: ",details);
            let _data = "";
           
            _data = window.dataTrackingClose;
            // FRUSitecore.triggerGoal('data-tracking-close');
            FRUSitecore.triggerGoal(_data);
          
        });

        FundraiseUp.on('donationComplete', function(details) {
            /* eslint-disable-next-line */
            //console.log('DONATION COMPLETE ::::::::::::::::::'); // Donation complete
            /* eslint-disable-next-line */
           
            console.log('DONATION COMPLETE ::::::::::::::::::'); 
            console.log("Donation Details:", details);
            let _goalData = "";
            if(window.dataTrackingComplete == undefined){
                return;
            }
            _goalData = window.dataTrackingComplete;
            FRUSitecore.triggerGoal(_goalData);
            FRUSitecore.sendData(FRUSitecore.donationEndpoint, FRUSitecore.mapData(details));
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/fundraise-up.js